//Messages.js

import React, { useState } from 'react';
import { Box } from '@mui/material';
import MessagesTab from '../MessagesTab';
import SmtpTab from '../SmtpTab';
import { PageShell, Tabs, Tab, acmeTabsSx } from '../ui';
import 'react-quill/dist/quill.snow.css';

function Messages() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <PageShell>
      <Tabs value={currentTab} onChange={handleChangeTab} sx={acmeTabsSx}>
        <Tab label="Messages" />
        <Tab label="SMTP" />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {currentTab === 0 && <MessagesTab />}
        {currentTab === 1 && <SmtpTab />}
      </Box>
    </PageShell>
  );
}

export default Messages;
